import { useState } from 'react';
import { LocaleEnum } from 'schema/locale';
import { MILLISECONDS_IN_MINUTE } from '@portal/constants/time-constants';
import { useInterval } from './useInterval';
import { useLocale } from './useLocale';

export const useLiveSupportOnline = (supportLocale: LocaleEnum, isWorkingHours: () => boolean) => {
  const locale = useLocale();
  const [isOnline, setIsOnline] = useState(locale === supportLocale ? isWorkingHours() : true);

  useInterval(
    () => {
      const isOnlineLocal = isWorkingHours();
      setIsOnline(isOnlineLocal);
    },
    locale === supportLocale ? MILLISECONDS_IN_MINUTE : null
  );

  return isOnline;
};
